import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

let _client = null;

// Browser Supabase client used ONLY for Realtime dashboard subscriptions.
// It never carries staff credentials — all privileged reads/writes go through
// the authenticated FastAPI backend (service-role). Returns null if unconfigured.
export function getSupabase() {
  if (!url || !anon) return null;
  if (!_client) {
    _client = createClient(url, anon, {
      auth: { persistSession: false, autoRefreshToken: false },
    });
  }
  return _client;
}
